import { AbstractControl, ValidatorFn } from '@angular/forms';

export class OptiValidator {

 static templateMessages = {
    myValidator: 'El valor debe de estar comprendido entre 0 y 99.',
    rangeUnitsValidator: 'Entre 0 y el número máximo de unidades disponibles.',
    required: 'Introduzca un valor para el campo.',
    email: 'Introduza un email válido.',
    maxlength: 'Se ha superado el valor máximo de caracteres.',
    minlength: 'Se requiere un número mayor de caracteres.'
 };

// -----------------------------------
//      VALIDADORES CUSTOMIZADOS
// -----------------------------------

 // Validador sin parámetros.
 static myValidator(c: AbstractControl): {[key: string]: boolean} | null {
    if (c.value !== null && (isNaN(c.value) || c.value < 0 || c.value > 99)) {
       return {'myValidator': true};
    }
    return null;
 } // End function myValidator

 // Validador con parámetros.
 static rangeUnitsValidator(min: number, max: number): ValidatorFn {
  return(c: AbstractControl): {[key: string]: boolean} | null  => {
      if (c.value !== null && (isNaN(c.value) || c.value < min || c.value > max)) {
        return {'rangeUnitsValidator': true};
      }
      return null;
  };
 } // End function rangeUnitsValidator

} // End class OptiValidator
